import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getBtsHistoryRequest: ['payload'],
    getBtsHistorySuccess: ['response'],
    getBtsHistoryFailure: ['error'],
})

export const getBtsHistoryTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
})

/* ------------- Reducers ------------- */

const getBtsHistoryRequest = state => state.merge({ success: null })

const getBtsHistorySuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const getBtsHistoryFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_BTS_HISTORY_REQUEST]: getBtsHistoryRequest,
    [Types.GET_BTS_HISTORY_SUCCESS]: getBtsHistorySuccess,
    [Types.GET_BTS_HISTORY_FAILURE]: getBtsHistoryFailure,
})
